import React from "react";
import { BUILD_VERSION, formatDeployStamp } from "@/lib/version";

/**
 * Minimal build-version + last-deployed badge.
 *
 * Single low-contrast line of `label-mono` text — same typographic family
 * as the existing footer/eyebrow labels — so it blends with the chrome
 * instead of competing with it. Designed for the foot of public pages
 * (Landing, Login) and the bottom of the in-app sidebar.
 *
 * Props
 *   align       "left" | "center" | "right"   default: "center"
 *   className   extra Tailwind classes applied to the outer element
 */
export default function BuildBadge({ align = "center", className = "" }) {
  const justify =
    align === "left" ? "text-left"
    : align === "right" ? "text-right"
    : "text-center";
  const stamp = formatDeployStamp();
  return (
    <div
      data-testid="build-badge"
      className={`label-mono text-muted-foreground/70 select-none ${justify} ${className}`}
      title={`Sovereign VDR v${BUILD_VERSION} — last deployed ${stamp}`}
    >
      v{BUILD_VERSION}
      <span className="mx-2 opacity-50">·</span>
      Last&nbsp;Deployed&nbsp;{stamp}
    </div>
  );
}
